export default __webpack_public_path__ + "static/2016-d8207862c796d3c73d368487a579d541.svg";